import badwords from "./offensive-words.data";

const badwordsSet = new Set(badwords);

interface UserField {
  name: string;
  value: string;
}

export const unacceptableInputs = (inputs: UserField[]): string[] => {
  const unacceptableFieldNames: string[] = [];

  for (const input of inputs) {
    if (badwordsSet.has(input.value.toLocaleLowerCase())) {
      unacceptableFieldNames.push(input.name);
    }
  }

  return unacceptableFieldNames;
};
